
export default function Technologies() {
  return (
    <section id="about" className="py-12 pt-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-[36px] md:text-[45px] lg:text-[54px] font-light text-[#F3220B] mb-8">About</h2>
        
        <div className="text-sm md:text-base lg:text-lg text-gray-700 leading-relaxed space-y-3">
          <p>
            CandyVoice is a French deep-tech company specialising in real-time digital processing of the human voice for telecommunications and tactical radio-communication systems. We develop a proprietary technology architecture combining DSP and AI, made up of advanced, modular and interoperable voice building blocks, designed to ensure communication quality, robustness and security in constrained environments.
          </p>
          
          <div>
            <p>Our technologies notably include:</p>
            <ul className="list-disc list-inside ml-4">
              <li>Voice Anonymisation</li>
              <li>Voice Deepfake Detection</li>
              <li>Noise Reduction & Speech Enhancement</li>
              <li>and Packet Loss Concealment</li>
            </ul>
          </div>
          
          <p>
            Designed for fully local (on-device) operation, with no cloud dependency, these building blocks are optimised for CPU/ARM and DSP architectures, ensuring low power consumption, ultra-low latency and operational robustness. Deployable individually or in combination, they can be integrated as embedded or custom solutions via SDKs into radios, intercoms, telecom infrastructures and C4ISR systems, within sovereign, GDPR- and AI Act-compliant, ITAR-free solutions.
          </p>
        </div>
      </div>
    </section>
  );
}
